import crud from "../../../../stores/crud";

const getDefaultState = () => {
	return {
		...crud.state,
		routes: {
			index: "introductions",
			show: "introductions/:introduction",
		},
		formReady: false,
		form: null,
	};
};

const state = getDefaultState();

export default {
	namespaced: true,
	state,
	actions: {
		...crud.actions,
	},
	mutations: {
		...crud.mutations,
		setForm(state, form) {
			state.form = form;
		},
		setFormReady(state, value) {
			state.formReady = value;
		},
		LOADED(state) {
			state.loaded = true;
		},
		COMPARISON_INSTRUCTED(state, payload) {
			let service = _.find(state.activeItem.services, ["id", payload.service.id]);
			let comparison = service.pivot.comparison;
			let serviceProvider = _.find(comparison.serviceProviders, ["id", payload.serviceProvider.id]);
			service.pivot.instruction = payload;
			comparison.active_instruction = payload;
			serviceProvider.pivot.instruction = payload;
		},
	},
	getters: {
		...crud.getters,
	},
};
